import { tt } from "../i18n";

// Turns an uploaded photo into a small square JPEG data URL (~5-15 KB) so it
// can live directly in the profile document and room player entries.
export const AVATAR_PX = 128;
export const MAX_AVATAR_CHARS = 40000; // keep in sync with firestore.rules

export async function fileToAvatar(file) {
  if (!file || !file.type.startsWith("image/")) throw new Error(tt("Please pick an image file."));
  if (file.size > 15 * 1024 * 1024) throw new Error(tt("That image is too big (15 MB max)."));
  const url = URL.createObjectURL(file);
  try {
    const img = await new Promise((resolve, reject) => {
      const i = new Image();
      i.onload = () => resolve(i);
      i.onerror = () => reject(new Error(tt("Couldn't read that image.")));
      i.src = url;
    });
    const side = Math.min(img.naturalWidth, img.naturalHeight);
    const sx = (img.naturalWidth - side) / 2;
    const sy = (img.naturalHeight - side) / 2;
    const canvas = document.createElement("canvas");
    canvas.width = AVATAR_PX;
    canvas.height = AVATAR_PX;
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, AVATAR_PX, AVATAR_PX);
    ctx.imageSmoothingQuality = "high";
    ctx.drawImage(img, sx, sy, side, side, 0, 0, AVATAR_PX, AVATAR_PX);
    for (const q of [0.85, 0.7, 0.55]) {
      const data = canvas.toDataURL("image/jpeg", q);
      if (data.length <= MAX_AVATAR_CHARS) return data;
    }
    throw new Error(tt("Couldn't shrink that image enough, try another one."));
  } finally {
    URL.revokeObjectURL(url);
  }
}
